var React = require('react');

function StatisticLine (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_288_6283)","key":0},React.createElement("path",{"d":"M39.2253 30.5L23.3919 14.6667L15.0586 23L2.55859 10.5","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"})),React.createElement("path",{"d":"M38.8916 22.5L39.7511 29.376C39.8257 29.9728 39.3603 30.5 38.7588 30.5H31.8916","stroke":"#01C716","strokeWidth":"2","strokeLinecap":"round","key":1}),React.createElement("defs",{"key":2},React.createElement("clipPath",{"id":"clip0_288_6283"},React.createElement("rect",{"width":"40","height":"40","fill":"white","transform":"matrix(1 0 0 -1 0.891602 40.5)"})))]);
}

StatisticLine.defaultProps = {"width":"41","height":"41","viewBox":"0 0 41 41","fill":"none"};

module.exports = StatisticLine;

StatisticLine.default = StatisticLine;
